import { useRoutes, useNavigate } from 'react-router-dom';
import authClass from '../utils/authclass'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react'
// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import {FrontRoutes, SecondRoute} from './FrontRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
   //sanjiv
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const auth = authClass.getUserSession()
   const session = useSelector((state) => state.session);

   let RoutingArray = [] //

   let checkurl = window.location.pathname
   checkurl = checkurl.match('/admin');
   if(checkurl) {
     RoutingArray.push(AuthenticationRoutes) // set admin loggin routing
     RoutingArray.push(MainRoutes) // set routing only if admin url matched
   }else{ 
    RoutingArray.push(FrontRoutes) // set admin loggin routing
    RoutingArray.push(SecondRoute) // set routing only if admin url matched
   }
   
   useEffect(() => { 

     if(!session?.isloggedin){
        dispatch({type:'LOGGEDIN',profile:auth, isloggedin: true})
     }

     if(!auth?.token && checkurl) { 
       navigate('/login') 
     }

     if(session.profile?.user?.tp!=authClass.adminKeyForLogin() && checkurl) { 
      navigate('/login') 
    }
     
   }, [])
 //end

  return useRoutes(RoutingArray);
}
